import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { useAuth } from "../context/AuthContext";
import "../styles/loans.css";

export default function Loans() {
  const { user } = useAuth();
  const [loan, setLoan] = useState(null);

   function formatDate(dateStr) {
    if (!dateStr) return "";

    const date = new Date(dateStr);

    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric"
    });
  }


  useEffect(() => {
  if (!user?.phoneNumber) return;

  const phone = user.phoneNumber
    .replace(/\D/g, "")
    .slice(-10);

  console.log("Clean Phone:", phone);

  const fetchLoan = async () => {
    const ref = doc(db, "loans", phone);
    const snap = await getDoc(ref);

    if (snap.exists()) {
      setLoan(snap.data());
    } else {
      console.log("No document found in Firestore");
    }
  };

  fetchLoan();
}, [user]);

  if (!user?.phoneNumber) {
    return <p className="loan-empty">Login with mobile number</p>;
  }

  if (!loan) {
    return <p className="loan-empty">No Loan Found</p>;
  }

  const progress =
    (loan.totalPaid / loan.totalToPay) * 100 || 0;

  return (
    <div className="loan-page">

      {/* 🔵 Main Card */}
      <div className="loan-card">
        <h2>₹{loan.loanAmount}</h2>
        <p>Total Loan</p>

        <div className="status">
          {loan.status === "Closed" ? "✅ Closed" : "🟡 Active"}
        </div>
      </div>

      {/* 🟢 Progress */}
      <div className="loan-progress">
        <div className="progress-text">
          <span>Paid: ₹{loan.totalPaid}</span>
          <span>Total: ₹{loan.totalToPay}</span>
        </div>

        <div className="progress-bar">
          <div
            className="progress-fill"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
      </div>

      {/* 🔴 Balance */}
      <div className="loan-balance">
        <h3>Balance</h3>
        <h1>₹{loan.balance}</h1>
      </div>

      {/* 📅 Details */}
      <div className="loan-details">
  <p><strong>EMI:</strong> ₹{loan.emi}</p>

  {/* ✅ NEW LINE */}
  <p><strong>Total Installments:</strong> {loan.months}</p>

  <p><strong>Start:</strong> {formatDate(loan.startDate)}</p>
  <p><strong>End:</strong> {formatDate(loan.endDate)}</p>
  <p><strong>Interest:</strong> {loan.interest}%</p>
</div>

    </div>
  );
}